// import menuList from '@/common/menuList1';
import http from '@/fetch';
const state = {
  menuList: [],
  subMenuList: [],
  authList: [],
  productShortList: [],
};
const getters = {};

const mutations = {

};
const actions = {
  // 业务渠道编码列表
  async getProductShortList(context) {
    let list = [];
    if (!context.state.productShortList || !context.state.productShortList.length) {
      const res = await http.get('/paycenter-charge/api/facade/product/listAllProductShortInfo');
      if (res.success) {
        list = res.data;
        context.state.productShortList = list;
        
      }
    }
    return context.state.productShortList;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
